import { StatesModule } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { AccessGuardService } from '../auth/services/access-guard.service';
import { SCHEDULE_ACCESS } from '../auth/types/access-level';
import { ScheduleAddComponent } from './components/schedule-add/schedule-add.component';
import { ScheduleDetailsComponent } from './components/schedule-details/schedule-details.component';
import { ScheduleListComponent } from './components/schedule-list/schedule-list.component';
import { SchedulesViewportComponent } from './schedules-viewport/schedules-viewport.component';
import { PlaylistService } from './services/playlist.service';
import { ScheduleService } from './services/schedule.service';

export const routes: StatesModule = {
  states: [
    {
      name: 'apps.schedules',
      abstract: true,
      component: SchedulesViewportComponent,
      resolve: [
        {
          token: 'requireSchedulesAccess',
          deps: [Transition, AccessGuardService],
          resolveFn: (transition, accessGuardService: AccessGuardService) =>
            accessGuardService.requireSchedulesAccess(transition),
        },
      ],
    },
    {
      name: 'apps.schedules.home',
      url: '/schedules',
      redirectTo: 'apps.schedules.list',
    },
    {
      name: 'apps.schedules.list',
      url: '/schedules/list/{folderId:any}',
      params: {
        folderId: null,
      },
      component: ScheduleListComponent,
    },
    {
      name: 'apps.schedules.add',
      url: '/schedules/add',
      params: {
        presentationItem: null,
        folderId: null,
      },
      component: ScheduleAddComponent,
      resolve: [
        {
          token: 'requireScheduleFullAccess',
          deps: [Transition, AccessGuardService],
          resolveFn: (transition, accessGuardService: AccessGuardService) =>
            accessGuardService.requireAccess(
              SCHEDULE_ACCESS.FULL_ACCESS,
              transition,
            ),
        },
        {
          token: 'scheduleAdd',
          deps: [
            Transition,
            ScheduleService,
            PlaylistService,
            'requireScheduleFullAccess',
          ],
          resolveFn: (transition, scheduleService, playlistService) => {
            scheduleService.newSchedule();

            if (transition.params().presentationItem) {
              return playlistService.addPresentationItem(
                transition.params().presentationItem,
              );
            }
          },
        },
      ],
    },
    {
      name: 'apps.schedules.details',
      url: '/schedules/details/:scheduleId',
      component: ScheduleDetailsComponent,
      resolve: [
        {
          token: 'scheduleInfo',
          deps: [Transition, ScheduleService],
          resolveFn: (transition, scheduleService) => {
            return scheduleService.getSchedule(transition.params().scheduleId);
          },
        },
      ],
    },
  ],
};
